import { render, staticRenderFns } from "./BlogArticles.vue?vue&type=template&id=07dd5362&scoped=true&"
import script from "./BlogArticles.vue?vue&type=script&lang=js&"
export * from "./BlogArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dd5362",
  null
  
)

export default component.exports